import React from "react";
import _ from "lodash";
import Filter from "./Filter";
import Vehicle from "./Vehicle";
import Divider from "../Common/Divider";
import {useSelector} from "react-redux";
import Loader from "../Common/Loader";
import NotFound from "../Common/NotFound";

const Vehicles = () => {
    const vehicle = useSelector(state => state.vehicle);
    const isLoading = useSelector(state => state.loader);

    return (
        <>
            <Filter/>
            <Divider/>
            {//Vehicles set to null is the starting state for the store
                //Meaning no filter has happened yet
                isLoading ? (
                    <Loader/>
                ) : vehicle === null ? (
                    <span>
						Please use the filters above to find a vehicle by its VIN or Multimedia Device ID (optional)
				</span>
                ) : _.isEmpty(vehicle) ? (
                    <NotFound>The filter returned no matching vehicles...</NotFound>
                ) : (
                    <Vehicle/>
                )
            }
        </>
    );
};

export default Vehicles;